function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  hash
} = require('spark-md5');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate generatePickerOptionsFromArrayOfLabeledObjectsBehavior
  *
  * Behavior ingests an array of values and creates an options object with appropriate titles
  * (from labels) and keys that are hashes of the transcribed title. Options missing labels
  * or possessing labels that are empty strings are filtered out.
  *
  * values: list of proto-options
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  const entitledValues = (values || []).filter(option => option.label).map(baseObject => _objectSpread(_objectSpread({}, baseObject), {}, {
    title: baseObject.label,
    identifier: hash(baseObject.label)
  })).filter(option => option.label !== ' ');

  /* eslint-disable-next-line no-console */
  if (entitledValues.length === 0) console.log('None of the objects in the array posess labels');
  return entitledValues;
};
module.exports = {
  evaluate
};